import {
  API_URL
} from "shared/constants/api";

const EDUCATION_DIRECTIONS_URL =
  `${API_URL}/ti/api/v1/education-directions/`;


export const fetchEducationDirections =
  async ({
    signal
  } = {}) => {
    const response = await fetch(
      EDUCATION_DIRECTIONS_URL,
      {
        method: "GET",
        credentials: "include",
        signal
      }
    );

    if (!response.ok) {
      throw new Error(
        "Nie udało się pobrać oferty kształcenia."
      );
    }

    const data = await response.json();

    if (
      !data.directions ||
      typeof data.directions !== "object"
    ) {
      throw new Error(
        "Serwer zwrócił nieprawidłowe dane kierunków."
      );
    }

    return data.directions;
  };